/**
 * Общая логика синхронизации вкладок с query-параметрами маршрута.
 * Используется BaseTabs и не обращается к Vue Router напрямую.
 */

/**
 * Возвращает запрошенную вкладку, если она доступна. Для отсутствующего или
 * устаревшего значения URL возвращает вкладку по умолчанию.
 */
export function selectRouteTab({
  requestedTab,
  availableTabs,
  defaultTab,
}) {
  return availableTabs.includes(requestedTab)
    ? requestedTab
    : defaultTab;
}

/**
 * Возвращает новый query с выбранной вкладкой, сохраняя параметры страницы.
 */
export function buildTabQuery({ query, queryKey = "tab", tab }) {
  return { ...query, [queryKey]: tab };
}
